import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from '../../lib/bem/index';
import { removeFormatNumber } from './../../lib/utils/index';
import {
  updatePlazo,
  updateMonto,
  postCotizarSimulacion,
  updateMontosResp,
  postCaptcha,
} from './../../redux/reducers/simuladorFVGSlice';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import './plazoInput_component.scss';

const PlazoInputComponent = () => {
  const classes = cn('plazoInputComponent');
  const dispatch = useDispatch();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);

  const anio =
    parseInt(simuladorFVG.plazo) === 1
      ? `${simuladorFVG.plazo} año`
      : `${simuladorFVG.plazo} años`;

  const onChangeAnio = async (value) => {
    const token = await executeRecaptcha('ecowebapp');

    var plazo = 0;
    if (
      value === '+' &&
      simuladorFVG.plazo < process.env.REACT_APP_PLAZO_MAXIMO
    ) {
      dispatch(
        updatePlazo({
          plazo: parseInt(simuladorFVG.plazo) + 1,
        })
      );
      plazo = parseInt(simuladorFVG.plazo) + 1;
    } else if (
      value === '-' &&
      simuladorFVG.plazo > process.env.REACT_APP_PLAZO_MINIMO
    ) {
      dispatch(
        updatePlazo({
          plazo: parseInt(simuladorFVG.plazo) - 1,
        })
      );
      plazo = parseInt(simuladorFVG.plazo) - 1;
    }

    var param = simuladorFVG.parametros.filter(
      (item) =>
        item.plazo === parseInt(plazo) && item.moneda === simuladorFVG.moneda
    );
    var montoMinimo = param.length > 0 ? param[0].montoMinimo : 0;
    var montoMaximo = param.length > 0 ? param[0].montoMaximo : 0;

    var monto =
      simuladorFVG.monto === ''
        ? 0
        : parseFloat(removeFormatNumber(simuladorFVG.monto));

    if (
      monto >= parseFloat(montoMinimo) &&
      monto <= parseFloat(montoMaximo) &&
      monto !== 0
    ) {
      if (process.env.REACT_APP_ACTIVE_VALIDATION_RECAPTCHA === 'true') {
        dispatch(postCaptcha(token)).then((resp) => {
          if (resp.payload.datos.esValido) {
            dispatch(
              postCotizarSimulacion({
                idSimulacion: simuladorFVG.idSimulacion,
                moneda: simuladorFVG.moneda,
                monto: monto,
                plazo: plazo,
              })
            );
          }
        });
      } else {
        dispatch(
          postCotizarSimulacion({
            idSimulacion: simuladorFVG.idSimulacion,
            moneda: simuladorFVG.moneda,
            monto: monto,
            plazo: plazo,
          })
        );
      }
    } else {
      dispatch(
        updateMonto({
          monto: '',
        })
      );
      dispatch(updateMontosResp());
    }
  };

  return (
    <div className={classes()}>
      <div>
        <p className={classes('plazoInputComponent_text')}>Plazo</p>
        <p className={classes('plazoInputComponent_sub_text')}>
          Desde {process.env.REACT_APP_PLAZO_MINIMO} año hasta{' '}
          {process.env.REACT_APP_PLAZO_MAXIMO} años
        </p>
      </div>
      <div className={classes('plazoInputComponent_div')}>
        <button
          name="btnLeft"
          className={classes('left')}
          onClick={() => onChangeAnio('-')}
          disabled={
            simuladorFVG.plazo === parseInt(process.env.REACT_APP_PLAZO_MINIMO)
          }
        >
          -
        </button>
        <input name="txtPlazo" value={anio} autoComplete="off" disabled />
        <button
          name="btnRight"
          className={classes('right')}
          onClick={() => onChangeAnio('+')}
          disabled={
            simuladorFVG.plazo === parseInt(process.env.REACT_APP_PLAZO_MAXIMO)
          }
        >
          +
        </button>
      </div>
    </div>
  );
};

export default PlazoInputComponent;
